import httpClient, { httpClientWithoutLoading } from "./index";

const END_POINT = "pointers";

const pointers = () => httpClient.get(END_POINT);
const pointersQuery = () => httpClientWithoutLoading.get(END_POINT);

export { pointers, pointersQuery };
